import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.590088L2.00015 0.585938L0.585938 2.00015L3.58579 5H1V21H19.5858L22.0002 23.4144L23.4101 22.0045L2 0.594389L2.0043 0.590088ZM6.75 12.75C6.75 11.4694 7.20853 10.2958 7.97038 9.38459L9.39378 10.808C8.9894 11.3498 8.75 12.0219 8.75 12.75C8.75 14.5449 10.2051 16 12 16C12.7281 16 13.4002 15.7606 13.942 15.3562L15.3654 16.7796C14.4542 17.5415 13.2806 18 12 18C9.1005 18 6.75 15.6495 6.75 12.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18.766V5H17.618L16.118 2H7.88197L7.33266 3.09862L11.7403 7.50631C11.8264 7.50212 11.9129 7.5 12 7.5C14.8995 7.5 17.25 9.8505 17.25 12.75C17.25 12.8371 17.2479 12.9236 17.2437 13.0097L23 18.766Z"}}]};

const CameraOffFilled = Vue.extend<IconProps>({
  name: 'CameraOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'camera-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CameraOffFilled;
